import { createAvatarLauncherContainer } from './avatarLauncher';
import { appendToRoot } from './utils';
export var renderBubbleLauncher = function (loader, theme) {
    appendToRoot(createAvatarLauncherContainer(loader, theme, {
        isBubble: true
    }));
};
